import { DataModel } from 'common/models/utility-models/base-model';
import { studentInternshipDataModel } from './student-internship-detail-meta.model';

export class StudentInternshipDetailsModel extends DataModel {
  internshipMasterId: string = '';
  isStudentAvailable: number = 0;
  studentExamStartDate: any = '';
  yescheck: any = '';
  nocheck: any = '';
  studentExamEndDate: any = '';
  studentSummerVacationStartDate: any = '';
  studentSummerVacationEndDate: any = '';
  studentExpectedInternshipStartDate: any = '';
  studentExpectedInternshipEndDate: any = '';
  studentAvailabilityRemark: string = '';
  isExternalCompanyForInternship: number = 0;
  externalCompanyName: string = '';
  externalCompanyLocation: string = '';
  anotherInternshipYes: any = '';
  anotherInternshipNo: any = '';
  studentFeedback: [] = [];
  feedbackToInternshipByStudent = '';
  internshipCertificateFilename = '';
  isStudentContinued: number = 0;
  isStudentJoined: number = 0;
  reasonForNotJoined: string = '';
  isInternshipCertyVerified: string = '';
  internshipTitle: string = '';
  companyName: string = '';
  locName: string = '';
  locAddress: string = '';
  internshipProjectName: string = '';
  accommodationContactPerson: string = '';
  accommodationAddress: string = '';
  studentjoinedinternshipyes: any = '';
  studentjoinedinternshipno: any = '';
  isInternshipcompleted: any = '';
  isInternshipnotcompleted: any = '';
  internshipCertyPath: any = '';
  internshipCertificateDisplayFilename: any = '';
  reasonForNotContinued:string='';
  internshipStartDate:string='';
  internshipEndDate:string='';
  // studentFeedback:[]=[]
  tabNumber:string='';
}

export class StudentInternship {
  internshipMasterId: string = '';
  isStudentAvailable: string = '';
  studentExamStartDate: any = '';
  studentExamEndDate: any = '';
  studentSummerVacationStartDate: any = '';
  studentSummerVacationEndDate: any = '';
  studentAvailabilityRemark?: string = '';
  isExternalCompanyForInternship: string = '';
  externalCompanyName?: string = '';
  externalCompanyLocation?: string = '';
  studentExpectedInternshipStartDate: any = '';
  studentExpectedInternshipEndDate: any = '';
  id: any;
}

export class studentFeedback {
  id: number = 0;
  internshipCerty: string = '';
  isStudentJoined: string = '';
  isStudentContinued: string = '';
  reasonForNotJoined?: string = '';
  reasonForNotContinued?: string = '';
  feedbackQuestionResponse: {
    questionId: string;
    questionType: number;
    answer: string;
  }[] = [];
  // id: number;
}
